import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { useIsDesktop } from '@kanda-libs/ks-design-library';

export interface ApplyButtonHook {
  label: string;
  accepted: boolean;
}

export default function useApplyButton(
  selectNewRate?: boolean,
): ApplyButtonHook {
  const accepted = useWatch({ name: 'commission.value' });

  const isDesktop = useIsDesktop();

  const label = useMemo(() => {
    if (selectNewRate) return 'Apply with new rate';
    return isDesktop ? 'Accept Quote & Apply Now' : 'Accept Quote & Apply';
  }, [isDesktop, selectNewRate]);

  return {
    label,
    accepted,
  };
}
